import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { EMAIL_REGEX, STRICT_URL_PATTERN } from '../../../../constants/pattern.constant';
import FieldError from '../../../../shared/fields-errors/field-error';

function ProgramTermsAgreements(props) {
    const { register, setValue, watch, formState: {errors} } = useFormContext();
    const fieldsWatcher = watch()

    return (
        <>
            <div className='main-form-wrapper'>
                <h6 className="mb-3 text-black fw-bold">
                    <i className="fa-solid fa-file-contract text-primary me-2"></i>
                    Terms & Agreements
                </h6>
                <p className='text-muted f-12-small'>Add consent and policy acknowledgments for participants. Include a terms link or a parental consent statement to show before form submission.</p>

                {/* Link to Terms Page */}
                <div className='row mb-3'>
                    <div className='col-xxl-12 col-md-12'>
                        <Form.Group>
                            <Form.Label className='text-bold text-black'>Link to Terms Page</Form.Label>
                            <Form.Control 
                            {...register("terms_page_url", {
                                pattern: {
                                    value: STRICT_URL_PATTERN,
                                    message: "URL must start with http or https"
                                }
                            })}
                                type="text" 
                                placeholder="Enter URL"
                            />
                        </Form.Group>
                        {errors?.terms_page_url ? <FieldError message={errors?.terms_page_url?.message} /> : ''}
                    </div>
                </div>

                {/* Checkbox Label */}
                <div className='row mb-3'>
                    <div className='col-xxl-12 col-md-12'>
                        <Form.Group >
                            <Form.Label className='text-bold text-black'>Checkbox Label</Form.Label>
                            <Form.Control 
                                type="text" 
                                {...register("terms_checkbox_label")}
                                placeholder="Enter checkbox label"
                            />
                        </Form.Group>
                    </div>
                </div>

                {/* Consent Text */}
                <div className='row mb-3'>
                    <div className='col-xxl-12 col-md-12'>
                        <Form.Group >
                            <Form.Label className='text-bold text-black'>Consent Text</Form.Label>
                            <Form.Control 
                            {...register("consent_text")}
                                as="textarea"
                                rows={4}
                                placeholder="Enter consent text"
                            />
                        </Form.Group>
                    </div>
                </div>
            </div>

            {/* Confirmation & Notifications Section */}
            <div className='main-form-wrapper mt-4'>
                <h6 className="mb-3 text-black fw-bold">
                    <i className="fa-solid fa-bell text-primary me-2"></i>
                    Confirmation & Notifications
                </h6>
                <p className='text-muted f-12-small'>Customize what happens after registration is submitted. Set the success message, send confirmation emails, and choose who gets notified.</p>

                {/* Confirmation Message */}
                <div className='row mb-3'>
                    <div className='col-xxl-12 col-md-12'>
                        <Form.Group>
                            <Form.Label className='text-bold text-black'>Confirmation Message</Form.Label>
                            <Form.Control 
                            {...register("confirmation_message")}
                                as="textarea"
                                rows={3}
                                placeholder="Enter confirmation message"
                            />
                        </Form.Group>
                    </div>
                </div>

                {/* Confirmation Email Toggle */}
                <div className='row mb-3'>
                    <div className='col-xxl-12 col-md-12'>
                        <div className='d-flex align-items-center gap-3'>
                            <div className='d-flex gap-2'>
                                <button 
                                    type='button'
                                    className={`btn btn-sm ${fieldsWatcher?.send_confirmation_email ? 'btn-dark' : 'btn-outline-dark'}`}
                                    onClick={() => setValue('send_confirmation_email', true)}
                                >
                                    On
                                </button>
                                <button 
                                    type='button'
                                    className={`btn btn-sm ${!fieldsWatcher?.send_confirmation_email ? 'btn-dark' : 'btn-outline-dark'}`}
                                    onClick={() => setValue('send_confirmation_email', false)}
                                >
                                    Off
                                </button>
                            </div>
                            <Form.Label className='text-bold text-black mb-0'>Confirmation Email</Form.Label>
                        </div>
                        {/* <p className='text-muted f-12-small'>Sends an email copy of confirmation</p>

                        <button type='button' className='btn btn-outline-primary mt-2'>
                            Edit Email Template
                        </button> */}
                    </div>
                </div>

                {/* Additional Notification Email */}
                <div className='row'>
                    <div className='col-xxl-12 col-md-12'>
                        <Form.Group className="mb-3">
                            <Form.Label className='text-bold text-black'>Additional Notification Email</Form.Label>
                            <Form.Control 
                            {...register("additional_notification_email", {
                                 pattern: {
                                    value: EMAIL_REGEX,
                                    message: "Enter a valid email address"
                                }
                            })}
                                type="email" 
                                placeholder="Enter email address"
                            />
                        </Form.Group>
                        {errors?.additional_notification_email ? <FieldError message={errors?.additional_notification_email?.message} /> : ''}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProgramTermsAgreements;